<template>
    <div class="emd-text-content">
      <emd-text
        size="text"
        class="emd-text-content__title"
        data-testid="title"
      >
        {{ title }}
      </emd-text>
      <slot v-if="$slots.default"></slot>
      <emd-text
        v-else
        size="text"
        class="emd-text-content__text"
        data-testid="content"
      >
        {{ content }}
      </emd-text>
    </div>
  </template>

<script>
import EmdText from '../emdText/EmdText.vue'

export default {
  name: 'EmdTextContent',
  components: {
    EmdText
  },
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: [String, Number],
      default: () => '-'
    }
  }
}
</script>

  <style scoped>
  .emd-text-content {
    display: flex;
    flex-direction: column;
    row-gap: 4px;
  }

  .emd-text-content__title {
    color: var(--neutras-gray-300, #72737A);
  }

  .emd-text-content__text {
    max-width: 255px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  </style>
